import { DataBean } from "../DataBean";

export class NationalizationProcessItems extends DataBean {


    public async getNationalizationProcessItemsCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getNationalizationProcessItemsCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
 public async getNationalizationProcessItemsRender(idNationalizationProcessGeneralInfo:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getNationalizationProcessItemsRender_Number", [idNationalizationProcessGeneralInfo]);
    }

 
}